import { InputNumber as AntInputNumber } from "antd";
import styled, { css } from "styled-components";
import "./style/index.css?global";
export const InputNumber = styled(AntInputNumber).withConfig({
  displayName: "input-number__InputNumber",
  componentId: "sc-1ag6e8f-0"
})(["&::after{content:\"", "\";color:", ";position:absolute;top:4px;right:12px;transition:right 0.3s;}", ""], p => p.suffix, p => p.theme.colors.placeholder, p => !p.disabled && css(["&:hover::after,&.ant-input-number-focused::after{right:32px;}"]));
export default InputNumber;